<template>
  <div class="flex justify-between flex-align-center" style="padding: 5px">
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
          <span
            v-if="
              item.redirect === 'noRedirect' || index == levelList.length - 1
            "
            class="no-redirect"
            ><span>{{ item.meta.title }}</span></span
          >
          <router-link v-else :to="item.redirect || item.path">{{
            item.meta.title
          }}</router-link>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
    <div
      class="org-info flex flex-align-center"
      v-if="$store.getters.isEnterOrg"
    >
      <span
        >您当前所在机构:【{{ $store.getters.currentOrganizationName }}】</span
      >
      <el-button type="text" @click="currentOrgOut">退出当前机构</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route(route) {
      // 如果转到重定向页面，不更新面包屑
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    // 退出当前组织机构
    currentOrgOut() {
      this.$request
        .get("educationadmin/userInfo/exitOrganization", {})
        .then((res) => {
          if (res) {
            let orgInfo = {
              organizationId: res.currentOrganizationId,
              ordinary: res.ordinary,
              roleGroup: res.currentRoleGroup, // 2.教育局 3.学校 11.市教委  10.教育厅
              organizationName: res.currentOrganizationName,
            };
            window.sessionStorage.removeItem("currentEnterOrgInfo");
            // 更新进入后的组织机构信息
            this.$store.commit("updateOrgInfo", orgInfo);
            this.$store.commit("setEnterOrg", false);
            this.$store.commit("set_isordinary", res.isordinary);
            if (this.$route.path == "/home") {
              this.$router.push({ name: "reload" });
            } else {
              this.$router.push({ name: "home" });
            }
          }
        })
        .catch(() => {
          this.$message.error("退出当前组织机构操作错误,请联系管理员!");
        });
    },
    // 获取面包屑数据
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name);
      const first = matched[0];
      if (
        first &&
        first.name !== "home" &&
        this.$store.getters.currentRoleGroup != 8
      ) {
        matched = [
          { path: "/home", name: "home", meta: { title: "首页" } },
        ].concat(matched);
      }
      if (matched && matched.length > 0) {
        for (let i = 0; i < matched.length; i++) {
          let tmpMenu = this.$permission.GetMenuByName(matched[i].name);
          if (tmpMenu && tmpMenu != null && tmpMenu.length > 0) {
            matched[i].path = tmpMenu[0].url;
            matched[i].meta.title = tmpMenu[0].displayName;
          }
        }
      }

      this.levelList = matched.filter((item) => item.meta && item.meta.title);
    },
  },
};
</script>

<style scoped>
.app-breadcrumb.el-breadcrumb {
  font-size: 14px;
}
.app-breadcrumb.el-breadcrumb .no-redirect {
  color: rgb(1, 5, 138);
  cursor: text;
}
.org-info {
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  -webkit-transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #303133;
}
.org-info .el-button {
  margin-left: 20px;
}
.org-info .el-button:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue